export const PERMISSION_MANAGE_FRAUD = 'manage fraud';
export const PERMISSION_MANAGE_ECOSYSTEM = 'manage ecosystem';
export const PERMISSION_MANAGE_SUPPORT = 'manage support';
export const PERMISSION_RISK_DASHBOARD = 'risk dashboard';
export const PERMISSION_RISK_SUPPORT = 'risk support';
export const PERMISSION_HCP_ASSISTANT = 'hcp assistant';
export const PERMISSION_EDIT_ROLES = 'edit roles';
export const PERMISSION_HANDLE_DISPUTES = 'handle disputes';
export const PERMISSION_READ_ONLY_HANDLE_DISPUTES = 'read only handle disputes';
export const PERMISSION_MANAGE_FAILED_BILLING = 'manage failed billing';
export const PERMISSION_FAILED_BILLING_REP = 'failed billing rep';
export const PERMISSION_RISK_REP = 'risk rep';
export const PERMISSION_MANAGE_RISK = 'manage risk';
export const PERMISSION_MANAGE_HCP_DISPUTES = 'manage hcp disputes';
export const PERMISSION_HCP_DISPUTES_REP = 'hcp disputes rep';
export const PERMISSION_MANAGE_CHARGE_CARD_FINTECH = 'manage charge card fintech';
export const PERMISSION_IMPERSONATE_WRITE_ACCESS = 'impersonate write access';
export const PERMISSION_READ_ONLY_MANAGE_FRAUD = 'read only manage fraud';
export const PERMISSION_MANAGE_PROMO = 'manage promo';
export const PERMISSION_READ_ONLY_MANAGE_PROMO = 'read only manage promo';
export const PERMISSION_READ_ONLY_HCP_ASSISTANT = 'read only hcp assistant';
export const MANAGE_PAYROLL = 'manage payroll';
export const PERMISSION_BILLING_PROMO = 'billing promo';
export const PERMISSION_READ_ONLY_BILLING_PROMO = 'read only billing promo';
export const PERMISSION_CHARGE_ORGANIZATION = 'charge organization';
export const PERMISSION_READ_ONLY_CHARGE_ORGANIZATION = 'read only charge organization';
export const PERMISSION_READ_ONLY_REFUND_ORGANIZATION = 'read only refund organization';
export const PERMISSION_READ_ONLY_CHANGE_RENEWAL_DATE = 'read only change renewal date';
export const PERMISSION_READ_ONLY_EDIT_NUMBER_EMPLOYEES = 'read only edit number employees';
export const PERMISSION_IMPORT_FLAT_FILES = 'import flat files';
export const PERMISSION_READ_ONLY_MANAGE_SUPPORT_AND_FLAT_FILES = 'read only manage support and flat files';
export const PERMISSION_READ_ONLY_MANAGE_WEBSITE_BUILDER = 'read only manage website builder';
export const PERMISSION_READ_ONLY_ATTACH_BILLING_PLAN_OLD_ADMIN = 'read only attach billing plan old admin';
export const PERMISSION_READ_ONLY_MANAGE_ECOSYSTEM = 'read only manage ecosystem';
export const PERMISSION_READ_ONLY_RISK_DASHBOARD = 'read only risk dashboard';
export const PERMISSION_READ_ONLY_EDIT_EMPLOYEES = 'read only edit employees';
export const PERMISSION_READ_ONLY_RISK_SUPPORT = 'read only risk support';
export const PERMISSION_READ_ONLY_MANAGE_FAILED_BILLING = 'read only manage failed billing';
export const PERMISSION_REFUND_ORGANIZATION = 'refund organization';
export const PERMISSION_EDIT_NUMBER_EMPLOYEES = 'edit number employees';
export const PERMISSION_CHANGE_RENEWAL_DATE = 'change renewal date';
export const PERMISSION_MANAGE_WEBSITE_BUILDER = 'manage website builder';
export const PERMISSION_MANAGE_PRO_EMAIL = 'manage pro email';
export const PERMISSION_EDIT_EMPLOYEES = 'edit employees';
export const PERMISSION_BILLING_ACCOUNTING = 'billing accounting';
export const PERMISSION_ENABLE_ACCOUNTING = 'enable accounting'
export const PERMISSION_MANAGE_MOBILE_CHECK_DEPOSITS_RISKS = 'manage mobile check deposits risks';
export const PERMISSION_MANAGE_RESET_PASSWORD = 'manage reset password';
